import getTranslationKeysHook from 'bringg-web/utils/translation-keys-hook';

export const translateKeys = {
	dropHere: 'FILE_UPLOADER.DROP_HERE',
	browseFiles: 'FILE_UPLOADER.BROWSE_FILES'
};

export default getTranslationKeysHook<typeof translateKeys>(translateKeys);
